// eslint-disable-next-line import/no-anonymous-default-export
export default (phone) => {
  const regex = /^\d{10}$/;
  return regex.test(phone);
};
